import {NgModule} from '@angular/core';
import {ReplenishmentRoutingModule} from './replenishment-routing.module';
import {ReplenishmentComponent} from './replenishment.component';
import { ReplenishmentTableComponent } from 'src/app/widgets/replenishment-table/replenishment-table.component';

@NgModule({
	imports: [
		ReplenishmentRoutingModule,

		ReplenishmentTableComponent,
	],
	declarations: [ReplenishmentComponent],
})
export class ReplenishmentModule {}
